import API_BASE_URL from './config';
import React from 'react';

const LineartEditRegulations = () => {
  const pageStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '170px 20px 20px',
    fontFamily: 'Arial, sans-serif',
    color: '#333',
    lineHeight: '1.6'
  };

  const sectionStyle = {
    backgroundColor: '#E6F0FA',
    padding: '20px',
    borderRadius: '10px',
    marginBottom: '20px',
    boxShadow: '0 2px 5px rgba(0, 0, 0_PATTERN_0.1)'
  };

  const headingStyle = {
    color: '#1E88E5',
    fontSize: '2em',
    marginBottom: '15px'
  };

  const noteStyle = {
    color: '#1E88E5',
    fontStyle: 'italic',
    margin: '10px 0'
  };

  return (
    <div style={pageStyle}>
      <div style={sectionStyle}>
        <h1 style={headingStyle}>Lineart Edit Regulations</h1>
        <h4>Available Lineart Edit Items:</h4>
        <p>
        <ul style={{ listStyle: 'none', paddingLeft: '0' }}>
          <li>
            <strong>Ear Crop Item</strong>: Crop ears for breeds without a cropped variant. Not needed if the breed’s lineart includes cropped ears, unless customizing the crop style.
          </li>
          <li>
            <strong>Tail Dock Item</strong>: Dock tails for breeds without a docked variant. Not needed if the breed’s lineart includes docked tails, unless customizing the style.
          </li>
          <li>
            <strong>Lineart Edit Item</strong>: Create custom lineart for mixed breeds, custom fur, or expressions. The dog must stay stylistically similar, with no pose changes or added gear/decorations. Use for body modifications only.
          </li>
        </ul>
        </p>
        <p style={noteStyle}>
          Regulations are coming soon! Check back for updates on proper item usage.
        </p>
      </div>
    </div>
  );
};

export default LineartEditRegulations;